<template>
  <div>
    <b-modal ref="my-modal" centered hide-footer title="Edit Pengaturan">
      <form v-on:submit.prevent="doSubmit">
        <div>
          <label for="" class="mt-2 labels">{{$t('Day')}} *</label>
          <!-- <b-form-select required v-model="model.dayName" :options="nameOfDay"></b-form-select> -->
          <b-form-input v-model="model.dayName" readonly></b-form-input>
        </div>
        <div class="mt-2">
          <label for="" class="mt-2 labels">{{$t('startWorkTime')}} *</label>
          <b-form-timepicker
            id="datepicker-invalid"
            aria-required="true"
            :state="validateStartTime"
            h23
            v-model="model.startWorkTime"
          ></b-form-timepicker>
        </div>

        <div class="mt-2">
          <label for="" class="mt-2 labels">{{$t('endWorkTime')}} *</label>
          <b-form-timepicker
            aria-required="true"
            h23
            v-model="model.endWorkTime"
            :state="validateEndTime"
            required
          ></b-form-timepicker>
        </div>
        <div class="mt-2">
          <label for="" class="mt-2 labels">{{$t('offDay')}} </label>
          <b-form-checkbox
            name="check-button"
            switch
            size="lg"
            v-model="model.isOffDay"
            title="Active"
          ></b-form-checkbox>
        </div>
        <!-- <b-form-checkbox name="check-button" switch size="lg" v-model="model.isOffDay" title="Active" @change="changeSwitch([row.item.uuid, 'branch', row.item.isActive])"></b-form-checkbox>
       -->
        <b-button class="mt-4" variant="secondary" @click="hideModal"
          ><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button
        >
        <b-button class="mt-4 float-right" @click="doSubmit()" :disabled="disable" variant="primary" type="submit"
          ><font-awesome-icon icon="save"></font-awesome-icon>Update
        </b-button>
      </form>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      validateStartTime: false,
      validateEndTime: false,
      apiUrl: {
        attendanceSetting: window.AppConfig.apiUrl + 'attendance-settings',
      },
      model: {
        uuid: null,
        dayName: null,
        startWorkTime: '',
        endWorkTime: '',
        isOffDay: false,
      },
      nameOfDay: [
        {
          value: null,
          text: 'Please select Day',
        },
        {
          value: 'Monday',
          text: 'Monday',
        },
        {
          value: 'Tuesday',
          text: 'Tuesday',
        },
        {
          value: 'Wednesday',
          text: 'Wednesday',
        },
        {
          value: 'Thursday',
          text: 'Thursday',
        },
        {
          value: 'Friday',
          text: 'Friday',
        },
        {
          value: 'Saturday',
          text: 'Saturday',
        },
        {
          value: 'Sunday',
          text: 'Sunday',
        },
      ],
      columns: [
        {
          key: 'dayName',
          label: 'Day',
          sortable: false,
        },
        {
          key: 'startWorkTime',
          label: 'Start Work Time',
          sortable: false,
        },
        {
          key: 'endWorkTime',
          label: 'End Work Time',
        },
        {
          key: 'isOffDay',
          label: 'Off Day',
          sortable: false,
        },
        {
          key: 'actionTypes',
          label: '',
        },
      ],
    };
  },

  computed: {
    disable() {
      if (this.model.startWorkTime === '') {
        return true;
      } else if (this.model.endWorkTime === '') {
        return true;
      } else {
        return false;
      }
    },
  },

  watch: {
    'model.startWorkTime'(value) {
      if (value !== '') this.validateStartTime = true;
    },

    'model.endWorkTime'(value) {
      if (value !== '') this.validateEndTime = true;
    },
  },

  methods: {
    showModal(row) {
      this.model.uuid = row.uuid,
      this.model.dayName = row.dayName,
      this.model.startWorkTime = row.startWorkTime,
      this.model.endWorkTime = row.endWorkTime,
      this.model.isOffDay = row.isOffDay
      this.$refs['my-modal'].show();
    },
    hideModal() {
      this.$refs['my-modal'].hide();
    },
    doEdit(row) {
      this.$refs.editAttendanceSetting.showModal(row);
    },
    doShowModal(row) {
      this.$refs.editAttendanceSetting.showModal(row);
    },
    doSubmit() {
      this.model.isOffDay === true ? 1 : 0; 
      const isOff = this.model.isOffDay;
      this.$validator.validateAll().then(res => {
        if(res){
          if (this.model.uuid !== null) {
            this.$http
              .patch(this.apiUrl.attendanceSetting + '/' + this.model.uuid, {
                 dayName: this.model.dayName,
                 startWorkTime: this.model.startWorkTime,
                 endWorkTime: this.model.endWorkTime,
                 isOffDay: isOff === true ? 1 : 0  /** check if isOff value equals true(boolean), return value to 1(number) */
              })
              .then(() => {
                this.hideModal();
                this.$store.dispatch('notification/success', 'Setting Update Saved');
                this.$emit('getData');
              })
              .catch((error) => this.$store.dispatch('notification/error', error));
          } 
        }
      })
    },
  },
};
</script>
